/* tslint:disable:no-console */

// デバッグ用
export class DebugHelper
{
    public static DEBUG_MODE = true;

    public static trace(...messages: any[])
    {
        if(this.DEBUG_MODE && window.location.href.indexOf("labelten.labelyasan.com") < 0)
        {
            // デバッグモードかつ本番URLではないとき
            console.log(...messages);
        }
    }
    public static get isDebugMode()
    {
        return this.DEBUG_MODE && window.location.href.indexOf("labelten.labelyasan.com") < 0;
    }
}
